/**
 *
 * FlashCardDetail
 *
 */

import { mapGetters, mapMutations } from 'vuex';

// FlashCardExerciseTypeMixin
export const FlashCardFilterSwitchMixin = {
  name: 'FlashCardFilterSwitchMixin',

  computed: {
    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_flashCardFilterSwitch: 'flashCardFilterSwitch',
    }),

    c_cardExerciseType_switch_k() {
      let cardExerciseType_switch_k = '';
      if (this.c_isSequenceFlashCardExerciseType) {
        cardExerciseType_switch_k = 'sequenceSelected';
      } else if (this.c_isRandomFlashCardExerciseType) {
        cardExerciseType_switch_k = 'randomSelected';
      }
      return cardExerciseType_switch_k;
    },

    c_flashCardFilterSwitch() {
      return this.mg_flashCardFilterSwitch(this.c_cardExerciseType_switch_k);
    },
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_CHECK_FILTER_REVISE_SWITCH: 'CHECK_FILTER_REVISE_SWITCH',
    }),

    handleFilterSwitchInFilter() {
      this.mm_CHECK_FILTER_REVISE_SWITCH({
        k: this.c_cardExerciseType_switch_k,
        isCheck: !this.c_flashCardFilterSwitch,
      });
    },
  },
};
